import React from 'react';
import styled from 'styled-components';

import { NewsCard, Carousel } from 'components';
import { useCarousel } from 'hooks';
import Section from '../components/Section';
import Button from '../components/Button';
import './FeaturedBlogPosts.scss';

const ButtonsWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  align-items: center;
  padding: 0.3rem 4rem;
`;

const CardContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-column-gap: 4rem;
  grid-row-gap: 6.4rem;
  grid-template-columns: repeat(3, minmax(min-content, 1fr));

  ${({ theme }) => theme.breakpoints.maxMobile} {
    grid-template-columns: minmax(min-content, 1fr);
    grid-template-rows: auto auto auto;
  }
`;

const CardsSection = ({ cards, button }) => (
  <CardContainer>
    {cards.map(({ node: { card } }, index) => (
      <NewsCard
        image={card.imageContainer.image.childImageSharp.fluid}
        date={card.date}
        tag={card.tag}
        title={card.title}
        description={card.description}
        link={card.path}
        key={card.title}
        index={index}
      />
    ))}
    {button && (
      <Button className="featured-blog-posts__button-mobile" to={button.to} variant="secondary">
        {button.text}
      </Button>
    )}
  </CardContainer>
);

const FeaturedBlogPosts = ({ subTitle, title, button, cards, className, carousel }) => {
  const itemCount = cards.length;
  const { prevHandler, nextHandler, currentPosition } = useCarousel(itemCount);

  return (
    <Section subTitle={subTitle} title={title} button={button} className={className}>
      {carousel ? (
        <>
          <ButtonsWrapper>
            <Carousel.Buttons
              itemCount={itemCount}
              prevHandler={prevHandler}
              nextHandler={nextHandler}
              currentPosition={currentPosition}
            />
          </ButtonsWrapper>

          {/* @TODO temporary offset for now to move by one item while there are only 3 blog posts */}
          <Carousel.Container offset={100 / 3} currentPosition={currentPosition}>
            <CardsSection cards={cards} button={button} />
          </Carousel.Container>
        </>
      ) : (
        <CardsSection cards={cards} button={button} />
      )}
    </Section>
  );
};

export default FeaturedBlogPosts;
